import { KnownMembership, MatrixClient } from 'matrix-js-sdk/src/matrix';

/** Matrix users already joined or pending invite in a room — used to hide them from invite pickers. */
export const getJoinedOrInvitedMemberIds = (matrixClient: MatrixClient, roomId?: string): Set<string> => {
  if (!roomId) return new Set();

  const room = matrixClient.getRoom(roomId);
  if (!room) return new Set();

  return new Set(
    room
      .getMembers()
      .filter((m) => m.membership === KnownMembership.Join || m.membership === KnownMembership.Invite)
      .map((m) => m.userId)
  );
};
